import { memo } from "react";

export type TrainEventHeaderProps = {
  imgProps: React.ImgHTMLAttributes<HTMLImageElement>;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

function TrainEventHeader({
  imgProps,
  style,
  ...props
}: TrainEventHeaderProps) {
  return (
    <a
      rel="noreferrer"
      target="_blank"
      {...props}
      style={{
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
        ...style,
      }}
    >
      <img alt="None" style={{ width: "100%" }} {...imgProps} />
    </a>
  );
}

export default memo(TrainEventHeader);
